import { __assign } from "tslib";
import { formatDollars } from '../../../../utils/formatting';
var printAdapter = function (props) {
    var _a, _b;
    var deviation = props.deviation;
    var price = ((_a = deviation.print) === null || _a === void 0 ? void 0 : _a.lowestPrice) !== undefined
        ? formatDollars((_b = deviation.print) === null || _b === void 0 ? void 0 : _b.lowestPrice)
        : '$???';
    return __assign(__assign({}, props), { price: price, priceLabel: 'shop.thumb.from', priceLabelOnTop: true });
};
export default printAdapter;
//# sourceMappingURL=print.new_price_format.js.map